/************************************************************************
	
	Theme:		Sunlight
	Version:	1.0
	Author:		Paolo Manganiello 
	Author URI:	http://paolomanganiello.com	

*************************************************************************/


// Superfish Dropdown

jQuery(function() {
  jQuery('ul.sf-menu').superfish({
    animation: { height: 'show' }, // slide-down animation
    speed: 'fast', // faster animation speed
    autoArrows: false
  });
});
	
// Jquery Colour 

$(window).load(function() {
	$('.item img').hover(function(){
		$(this).stop().animate({backgroundColor: '#eaeaea;'});
	}, function() {
		$(this).stop().animate({backgroundColor: '#f9f9f9'});
	});
});
